export default [{
    header: 'Anuncios',
    icon: 'BellIcon',
    children: [{
        title: 'Lista',
        route: 'notices',
        icon: 'ListIcon'
    }, {
        title: 'Agregar',
        route: 'notices-create',
        icon: 'MousePointerIcon'
    }, ]
}];